import React, { useEffect, useRef, useState } from "react";
import { CheckCircle2 } from "lucide-react";

export const ScrollCheck = ({ className = "", ...props }) => {
  const icon = useRef(null);
  const [revealed, setRevealed] = useState(false);
  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") { setRevealed(true); return undefined; }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setRevealed(true); observer.disconnect(); }
    }, { threshold: 0.5 });
    observer.observe(icon.current);
    return () => observer.disconnect();
  }, []);
  return <CheckCircle2 {...props} ref={icon} className={`scroll-check ${className}`} data-revealed={revealed} />;
};
